import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '@env/app-config';
import { CallSessionDTO, SignalType } from '../models/video-call.model';

/**
 * Solo HTTP -- crear/contestar/colgar una llamada y mandar señales WebRTC. Recibir eventos en
 * vivo (invitación, señales del otro lado, fin de llamada) es responsabilidad de
 * `RealTimeService` (ya escucha 'call.*' vía SSE, ver real-time.service.ts); este servicio no se
 * suscribe a nada, solo emite.
 */
@Injectable({ providedIn: 'root' })
export class VideoCallService {
  private http = inject(HttpClient);
  private apiUrl = `${AppConfig.apiUrl}/api/videocalls`;

  startCall(channelId: number, companyId: number): Observable<CallSessionDTO> {
    return this.http.post<CallSessionDTO>(`${this.apiUrl}/channels/${channelId}/start`, {}, { params: { companyId } });
  }

  getActiveCall(channelId: number): Observable<CallSessionDTO | null> {
    return this.http.get<CallSessionDTO>(`${this.apiUrl}/channels/${channelId}/active`, { observe: 'body' });
  }

  answerCall(callId: number): Observable<CallSessionDTO> {
    return this.http.post<CallSessionDTO>(`${this.apiUrl}/${callId}/answer`, {});
  }

  declineCall(callId: number): Observable<CallSessionDTO> {
    return this.http.post<CallSessionDTO>(`${this.apiUrl}/${callId}/decline`, {});
  }

  endCall(callId: number): Observable<CallSessionDTO> {
    return this.http.post<CallSessionDTO>(`${this.apiUrl}/${callId}/end`, {});
  }

  sendSignal(callId: number, type: SignalType, payload: string): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${callId}/signal`, { type, payload });
  }
}
